import { Injectable } from '@angular/core';

import { ReactShellConfig } from '../../../ts/ReactShellConfig';
import { ConfigParserService } from '../services/config-parser.service';

@Injectable({
    providedIn: 'root'
})
export class ReactShellConfigService {
    public readonly reactShellConfig: ReactShellConfig;

    constructor(
        configParserService: ConfigParserService
    ) {
        // Initialize to default values if there was failure to read user context from page response
        this.reactShellConfig = configParserService.parse<ReactShellConfig>('reactShellConfiguration') || {
            activityTimeout: 0,
            correlationId: null,
            culture: null,
            feedbackLinkText: null,
            homePageTitle: null,
            isConsumer: false,
            logoutText: null,
            logoutUrl: null,
            mePhotoSource: null,
            puid: null,
            responsiveShellEnabled: false,
            searchInHeader: false,
            shellBootHost: null,
            shellDelayResourcesEnabled: false,
            showOCVFeedbackLink: false,
            signinState: [],
            controlsClaim: [],
            stickyNotesEnabled: false,
            switchAccountLinkText: null,
            testTraffic: false,
            thirdPartyNoticeLinkText: null,
            thirdPartyNoticeUrl: null,
            upn: null,
            userDisplayName: null,
            version: null,
            workloadSettingsSubLinksTitle: null,
            darkModeEnabled: false,
            resourceUrl: null,
            environment: null,
            consumerShellServiceEnabled: false,
            languageCode: null,
            acctSwitchingConfig: null,
            meetNowLinkUrl: '',
            meetNowEnabled: false,
            disableAppLauncher: false
        };
    }
}
